import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ship-password',
  templateUrl: './ship-password.component.html',
  styleUrls: ['./ship-password.component.css']
})
export class ShipPasswordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
